import React from 'react';

const Footer = () => {
    return (
        <div className='mt-auto'>
            <div className='p-4 bg-dark text-white text-center'>
                Copyright &copy; Naimur Rashid Rahib 2022
            </div>
        </div>
    );
};

export default Footer;